export enum TipoDespesa {
  FUNCIONARIO = 'FUNCIONARIO',
  EMPRESA = 'EMPRESA',
  ADMINISTRATIVA = 'ADMINISTRATIVA',
}
